export default "__VITE_ASSET__DNBzHv$y__"